import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/tipos-de-alcoholes/';

/**
 * GET Tipos de Alcoholes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeAlcoholes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Alcoholes
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeAlcoholes = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Alcoholes
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeAlcoholes = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Alcoholes
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeAlcoholes = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Alcoholes
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeAlcoholes = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
